import { render } from "./video.vue?vue&type=template&id=48edd7ef&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=48edd7ef&lang=less&scoped=true"
import "./video.vue?vue&type=style&index=1&id=48edd7ef&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48edd7ef"]])

export default __exports__